import BillingsPlanEntryTaxiDriverDraftResponse, {
  BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionOther,
  BillingsPlanEntryTaxiDriverDraftResponseDataBonusContribution,
  BillingsPlanEntryTaxiDriverDraftResponseDataContributionType,
  BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionOther,
  BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionWrongRoute,
  BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContribution,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverDraftResponseDataContribution,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverUser,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverStartingAddress,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriver,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationFleetPartner,
  BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociation,
  BillingsPlanEntryTaxiDriverDraftResponseDataContract,
  BillingsPlanEntryTaxiDriverDraftResponseDataBillingNode,
  BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder,
  BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrder,
  BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrder,
  BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntry,
} from "../../../../../api/raily/billings/plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft.response";
import BillingsPlanEntryTaxiDriverDraft, {
  BillingsPlanEntryTaxiDriverDraftBonusContributionFavorableDistance,
  BillingsPlanEntryTaxiDriverDraftContributionType,
  BillingsPlanEntryTaxiDriverDraftBonusContributionOther,
  BillingsPlanEntryTaxiDriverDraftBonusContribution,
  BillingsPlanEntryTaxiDriverDraftPenaltyContributionOther,
  BillingsPlanEntryTaxiDriverDraftPenaltyContributionIncompatibleCar,
  BillingsPlanEntryTaxiDriverDraftPenaltyContributionBeingLate,
  BillingsPlanEntryTaxiDriverDraftPenaltyContributionWrongRoute,
  BillingsPlanEntryTaxiDriverDraftPenaltyContribution,
  BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionBaseAmountExternalTaxi,
  BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionOtherRate,
  BillingsPlanEntryTaxiDriverDraftContractCorrectionContribution,
  BillingsPlanEntryTaxiDriverDraftContribution,
  BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverUser,
  BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverStartingAddress,
  BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriver,
  BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationFleetPartner,
  BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociation,
  BillingsPlanEntryTaxiDriverDraftContract,
  BillingsPlanEntryTaxiDriverDraftBillingNode,
  BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrder,
  BillingsPlanEntryTaxiDriverDraftPlanEntry,
} from "./billings-plan-entry-taxi-driver-draft";

const createBillingBonusContributionFavorableDistance = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionFavorableDistance,
): BillingsPlanEntryTaxiDriverDraftBonusContributionFavorableDistance => {
  return {
    comment: contribution.comment,
    distance: contribution.distance,
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.BONUS_FAVORABLE_DISTANCE,
  };
};

const createBillingBonusContributionOther = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionOther,
): BillingsPlanEntryTaxiDriverDraftBonusContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.BONUS_OTHER,
  };
};

const createBillingBonusContribution = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataBonusContribution,
): BillingsPlanEntryTaxiDriverDraftBonusContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BONUS_FAVORABLE_DISTANCE:
      return createBillingBonusContributionFavorableDistance(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionFavorableDistance,
      );
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BONUS_OTHER:
      return createBillingBonusContributionOther(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataBonusContributionOther,
      );
  }
};

const createBillingPenaltyOther = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionOther,
): BillingsPlanEntryTaxiDriverDraftPenaltyContributionOther => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_OTHER,
  };
};

const createBillingPenaltyIncompatibleCar = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionIncompatibleCar,
): BillingsPlanEntryTaxiDriverDraftPenaltyContributionIncompatibleCar => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_INCOMPATIBLE_CAR,
  };
};

const createBillingPenaltyBeingLate = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionBeingLate,
): BillingsPlanEntryTaxiDriverDraftPenaltyContributionBeingLate => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_BEING_LATE,
  };
};

const createBillingPenaltyWrongRoute = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionWrongRoute,
): BillingsPlanEntryTaxiDriverDraftPenaltyContributionWrongRoute => {
  return {
    amount: contribution.amount,
    comment: contribution.comment,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.PENALTY_WRONG_ROUTE,
  };
};

const createBillingPenaltyContribution = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContribution,
): BillingsPlanEntryTaxiDriverDraftPenaltyContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_BEING_LATE:
      return createBillingPenaltyBeingLate(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionBeingLate,
      );
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_OTHER:
      return createBillingPenaltyOther(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionOther,
      );
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR:
      return createBillingPenaltyIncompatibleCar(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionIncompatibleCar,
      );
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyWrongRoute(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContributionWrongRoute,
      );
  }
};

const createBillingContractCorrectionContributionBaseAmountExternalTaxi = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionBaseAmountExternalTaxi,
): BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionBaseAmountExternalTaxi => {
  return {
    amount: contribution.amount,
    distance: contribution.distance,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.BASE_AMOUNT_EXTERNAL_TAXI,
  };
};

const createBillingContractCorrectionContributionOtherRate = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionOtherRate,
): BillingsPlanEntryTaxiDriverDraftContractCorrectionContributionOtherRate => {
  return {
    rate: contribution.rate,
    type: BillingsPlanEntryTaxiDriverDraftContributionType.CONTRACT_CORRECTION_RATE,
  };
};

const createBillingContractCorrectionContribution = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContribution,
): BillingsPlanEntryTaxiDriverDraftContractCorrectionContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
      return createBillingContractCorrectionContributionBaseAmountExternalTaxi(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionBaseAmountExternalTaxi,
      );
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContributionOtherRate(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContributionOtherRate,
      );
  }
};

const createBillingContribution = (
  contribution: BillingsPlanEntryTaxiDriverDraftResponseDataContribution,
): BillingsPlanEntryTaxiDriverDraftContribution => {
  switch (contribution.type) {
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BONUS_FAVORABLE_DISTANCE:
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BONUS_OTHER:
      return createBillingBonusContribution(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataBonusContribution,
      );
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_BEING_LATE:
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_OTHER:
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_INCOMPATIBLE_CAR:
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.PENALTY_WRONG_ROUTE:
      return createBillingPenaltyContribution(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataPenaltyContribution,
      );
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.BASE_AMOUNT_EXTERNAL_TAXI:
    case BillingsPlanEntryTaxiDriverDraftResponseDataContributionType.CONTRACT_CORRECTION_RATE:
      return createBillingContractCorrectionContribution(
        contribution as BillingsPlanEntryTaxiDriverDraftResponseDataContractCorrectionContribution,
      );
  }
};

const createBillingContributions = (
  contributions: BillingsPlanEntryTaxiDriverDraftResponseDataContribution[],
): BillingsPlanEntryTaxiDriverDraftContribution[] => {
  return contributions.map(createBillingContribution);
};

const createContractTaxiDriverAssociationDriverUser = (
  user: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverUser,
): BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverUser => {
  return {
    firstName: user.firstName,
    lastName: user.lastName,
  };
};

const createContractTaxiDriverAssociationDriverStartingAddress = (
  startingAddress: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriverStartingAddress,
): BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriverStartingAddress => {
  return {
    displayName: startingAddress.displayName,
  };
};

const createContractTaxiDriverAssociationDriver = (
  driver: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationDriver,
): BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationDriver => {
  return {
    startingAddress: createContractTaxiDriverAssociationDriverStartingAddress(
      driver.startingAddress,
    ),
    user: createContractTaxiDriverAssociationDriverUser(driver.user),
  };
};

const createContractTaxiDriverAssociationFleetPartner = (
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociationFleetPartner | null,
): BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociationFleetPartner | null => {
  return {
    name: taxiDriverAssociation?.name ?? "",
  };
};

const createContractTaxiDriverAssociation = (
  taxiDriverAssociation: BillingsPlanEntryTaxiDriverDraftResponseDataContractTaxiDriverAssociation,
): BillingsPlanEntryTaxiDriverDraftContractTaxiDriverAssociation => {
  return {
    driver: createContractTaxiDriverAssociationDriver(
      taxiDriverAssociation.driver,
    ),
    fleetPartner: createContractTaxiDriverAssociationFleetPartner(
      taxiDriverAssociation.fleetPartner,
    ),
  };
};

const createContract = (
  contract: BillingsPlanEntryTaxiDriverDraftResponseDataContract,
): BillingsPlanEntryTaxiDriverDraftContract => {
  return {
    description: contract.description,
    distanceRate: contract.distanceRate,
    haltingTimeAfterMinutes: contract.haltingTimeAfterMinutes,
    haltingTimeRate: contract.haltingTimeRate,
    model: contract.model,
    taxiDriverAssociation: createContractTaxiDriverAssociation(
      contract.taxiDriverAssociation,
    ),
  };
};

const createBillingNode = (
  node: BillingsPlanEntryTaxiDriverDraftResponseDataBillingNode,
): BillingsPlanEntryTaxiDriverDraftBillingNode => {
  return {
    allowCharge: node.allowCharge,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventId,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createBillingNodes = (
  nodes: BillingsPlanEntryTaxiDriverDraftResponseDataBillingNode[],
): BillingsPlanEntryTaxiDriverDraftBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createPlanEntrySolvedOrderTransportingOrderCargoOrder = (
  transportingOrder: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder,
): BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrderCargoOrder => {
  return {
    humanId: transportingOrder.humanId,
    id: transportingOrder.id,
  };
};

const createPlanEntrySolvedOrderTransportingOrder = (
  transportingOrder: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrder,
): BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrderTransportingOrder => {
  return {
    cargoOrder: createPlanEntrySolvedOrderTransportingOrderCargoOrder(
      transportingOrder.cargoOrder,
    ),
  };
};

const createPlanEntrySolvedOrder = (
  solvedOrder: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrder,
): BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrder => {
  return {
    transportingOrder: createPlanEntrySolvedOrderTransportingOrder(
      solvedOrder.transportingOrder,
    ),
  };
};

const createPlanEntrySolvedOrders = (
  solvedOrders: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntrySolvedOrder[],
): BillingsPlanEntryTaxiDriverDraftPlanEntrySolvedOrder[] => {
  return solvedOrders.map(createPlanEntrySolvedOrder);
};

const createPlanEntry = (
  planEntry: BillingsPlanEntryTaxiDriverDraftResponseDataPlanEntry,
): BillingsPlanEntryTaxiDriverDraftPlanEntry => {
  return {
    humanId: planEntry.humanId,
    solvedOrders: createPlanEntrySolvedOrders(planEntry.solvedOrders),
  };
};

const create = (
  response: BillingsPlanEntryTaxiDriverDraftResponse,
): BillingsPlanEntryTaxiDriverDraft => {
  const data = response.data;

  return {
    allContributionsAmount: data.allContributionsAmount,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    amountForDistance: data.amountForDistance,
    billingContributions: createBillingContributions(data.billingContributions),
    billingNodes: createBillingNodes(data.billingNodes),
    contract: createContract(data.contract),
    correctedContractModel: data.correctedContractModel,
    date: data.date,
    distance: data.distance,
    passengers: data.passengers,
    planEntry: createPlanEntry(data.planEntry),
    rateForDistance: data.rateForDistance,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
  };
};

const billingsPlanEntryDriverDraftFactory = {
  create,
};

export default billingsPlanEntryDriverDraftFactory;
